"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations, useLocale } from "next-intl";
import { useRouter, usePathname } from "@/i18n/navigation";
import EmailIcon from "@/assets/icons/ontario-icon-email.svg";
import AccountIcon from "@/assets/icons/ontario-icon-account.svg";
import DocumentIcon from "@/assets/icons/ontario-icon-document.svg";
import ExitIcon from "@/assets/icons/ontario-icon-exit.svg";
import { Header as CXPHeader, HeaderProps } from "@ops-gsic/cxp-component-library-react";
import { useTheme } from "@ops-gsic/cxp-component-library-react";
import { CustomMenuButtonStyled, HeaderBar } from "./styles";
import { NotificationMenu } from "./NotificationMenu";
import { useSession } from "next-auth/react";
import { useRef } from "react";
import { Profile } from "@/context/ProfileProvider";
import { useAppConfig } from "@/context/AppConfigProvider";
import { Message } from "@/types/inbox";
import { useSearchParams } from "next/navigation";
type AppHeaderProps = {
  profile: Profile | null;
  messages: Message[];
  unreadCount: number;
};
const AppHeader = t0 => {
  const $ = _c(74);
  const {
    profile,
    messages,
    unreadCount
  } = t0;
  const tm = useTranslations("Common.components.AppHeader.menu");
  const {
    status
  } = useSession();
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const menuButtonRef = useRef(null);
  const {
    theme
  } = useTheme();
  const {
    appConfig
  } = useAppConfig();
  const searchParams = useSearchParams();
  const isAuthenticated = status === "authenticated";
  const toggledLocale = locale === "en" ? "fr" : "en";
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams || $[3] !== toggledLocale) {
    t1 = () => {
      localStorage.setItem("cxp-i18n", toggledLocale);
      const queryString = searchParams.toString();
      const href = queryString ? `${pathname}?${queryString}` : pathname;
      router.push(href, {
        locale: toggledLocale
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = toggledLocale;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onLanguageToggle = t1;
  let t2;
  if ($[5] !== appConfig?.cxpWebBasePath || $[6] !== locale) {
    t2 = path => `${appConfig?.cxpWebBasePath}/${locale}${path}`;
    $[5] = appConfig?.cxpWebBasePath;
    $[6] = locale;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const baseHref = t2;
  let t3;
  if ($[8] !== tm) {
    t3 = tm("logoLink");
    $[8] = tm;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== tm) {
    t4 = tm("langLabel");
    $[10] = tm;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== tm) {
    t5 = tm("title");
    $[12] = tm;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = {
      title: "ServiceOntario",
      subTitle: t5
    };
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== tm) {
    t7 = tm("menuButtonLabel");
    $[16] = tm;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== tm) {
    t8 = tm("myInbox");
    $[18] = tm;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = baseHref("/notifications/inbox");
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <EmailIcon />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t8 || $[22] !== t9) {
    t11 = {
      title: t8,
      href: t9,
      icon: t10
    };
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== tm) {
    t12 = tm("myAccount");
    $[24] = tm;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = baseHref("/profile/details");
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <AccountIcon />;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t12 || $[28] !== t13) {
    t15 = {
      title: t12,
      href: t13,
      icon: t14
    };
    $[27] = t12;
    $[28] = t13;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== tm) {
    t16 = tm("myTransactions");
    $[30] = tm;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const t17 = baseHref("/transactions");
  let t18;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <DocumentIcon />;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t16 || $[34] !== t17) {
    t19 = {
      title: t16,
      href: t17,
      icon: t18
    };
    $[33] = t16;
    $[34] = t17;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== tm) {
    t20 = tm("signOut");
    $[36] = tm;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== router) {
    t21 = () => router.replace("/logout");
    $[38] = router;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ExitIcon />;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t20 || $[42] !== t21) {
    t23 = {
      title: t20,
      onClick: t21,
      icon: t22
    };
    $[41] = t20;
    $[42] = t21;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t11 || $[45] !== t15 || $[46] !== t19 || $[47] !== t23) {
    t24 = [t11, t15, t19, t23];
    $[44] = t11;
    $[45] = t15;
    $[46] = t19;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t24 || $[50] !== t6 || $[51] !== t7) {
    t25 = {
      variant: "ServiceOntario",
      titleInfo: t6,
      menuButtonLabel: t7,
      menuItems: t24
    };
    $[49] = t24;
    $[50] = t6;
    $[51] = t7;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== onLanguageToggle || $[54] !== t25 || $[55] !== t3 || $[56] !== t4) {
    t26 = {
      ontarioLogoLink: t3,
      languageToggleLabel: t4,
      onLanguageToggle,
      appHeader: t25
    };
    $[53] = onLanguageToggle;
    $[54] = t25;
    $[55] = t3;
    $[56] = t4;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  const headerConfig = t26;
  const t27 = !isAuthenticated;
  let t28;
  if ($[58] !== isAuthenticated || $[59] !== profile?.firstName || $[60] !== theme?.color?.white) {
    t28 = isAuthenticated ? t29 => {
      const {
        isMenuOpen,
        toggleMenu,
        ariaControls
      } = t29;
      return <CustomMenuButtonStyled ref={menuButtonRef} onClick={toggleMenu} aria-expanded={isMenuOpen} aria-controls={ariaControls} $isOpen={isMenuOpen}><AccountIcon aria-hidden="true" focusable="false" color={theme?.color?.white} className="ontario-icon" /><span> {profile?.firstName || "\xA0"}</span></CustomMenuButtonStyled>;
    } : undefined;
    $[58] = isAuthenticated;
    $[59] = profile?.firstName;
    $[60] = theme?.color?.white;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== isAuthenticated || $[63] !== messages || $[64] !== unreadCount) {
    t29 = isAuthenticated ? <NotificationMenu messages={messages} unreadCount={unreadCount} /> : null;
    $[62] = isAuthenticated;
    $[63] = messages;
    $[64] = unreadCount;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== headerConfig.appHeader || $[67] !== t27 || $[68] !== t28 || $[69] !== t29) {
    t30 = {
      ...headerConfig.appHeader,
      menuButtonRef: menuButtonRef as React.RefObject<HTMLElement>,
      hideMenuButton: t27,
      renderMenuButton: t28,
      children: t29
    };
    $[66] = headerConfig.appHeader;
    $[67] = t27;
    $[68] = t28;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== headerConfig || $[72] !== t30) {
    t31 = <HeaderBar><CXPHeader {...headerConfig} appHeader={t30} /></HeaderBar>;
    $[71] = headerConfig;
    $[72] = t30;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  return t31;
};
export default AppHeader;